import { type RoleNew } from "@vega-api/generated/types/roleNew";
import { useExpandableList } from "@vega-modules/hooks/useExpandableList";

export const MAX_VISIBLE_PERMISSIONS = 5;

type UsePermissionCollapseProps = {
  permissions: RoleNew["permissions"];
  maxVisible?: number;
};

export const usePermissionCollapse = ({
  permissions,
  maxVisible = MAX_VISIBLE_PERMISSIONS,
}: UsePermissionCollapseProps) => {
  const {
    visibleItems: visiblePermissions,
    hasMore: hasMorePermissions,
    remainingCount,
    isExpanded: showAll,
    toggle: toggleShowAll,
  } = useExpandableList({ items: permissions, maxVisible });

  return {
    visiblePermissions,
    hasMorePermissions,
    remainingCount,
    showAll,
    toggleShowAll,
  };
};
